import { Alert } from "react-bootstrap";

function ClassAccessDeniedAlert({ className = "m-4" }) {
  return (
    <Alert variant="warning" role="alert" className={className}>
      You currently don't have access to create this classroom level. If you
      think this is incorrect please email{" "}
      <a href="mailto:info@alpaca-assessment.com">
        info@alpaca-assessment.com
      </a>{" "}
      with your name, school roll number, along with any other teachers at your grade level that you feel might have the same issue.
    </Alert>
  );
}

export default ClassAccessDeniedAlert;
